var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const signalr_1 = require("@microsoft/signalr");
const getSignalRConnection_1 = __importDefault(require("./_base/getSignalRConnection"));
const parseISODates_1 = __importDefault(require("@hendersonengineers/utils/valueTransformers/parseISODates"));
const signalRConnectionIdsCache_1 = require("@hendersonengineers/utils/signalRConnectionIdsCache");
class HubClient {
    constructor(hubName) {
        this.hubName = hubName;
        this.hub = (0, getSignalRConnection_1.default)(hubName);
        this.started = false;
        this.wrapperMapping = new Map();
        this.hub.connection.onreconnected(connectionId => {
            (0, signalRConnectionIdsCache_1.addConnectionId)(connectionId);
            if (this.currentConnectionId) {
                (0, signalRConnectionIdsCache_1.removeConnectionId)(this.currentConnectionId);
            }
            this.currentConnectionId = connectionId;
        });
    }
    async start() {
        if (!this.started) {
            this.hub.registerListener();
            this.started = true;
        }
        if (this.hub.connection.state !== signalr_1.HubConnectionState.Disconnected) {
            return;
        }
        try {
            await this.hub.connection.start();
            this.currentConnectionId = this.hub.connection.connectionId;
            (0, signalRConnectionIdsCache_1.addConnectionId)(this.currentConnectionId);
        }
        catch (err) {
            console.error(`SignalR: connection to ${this.hubName} could not be started. ${err}`);
            this.hub.unregisterListener();
            this.started = false;
        }
    }
    async stop() {
        if (this.started) {
            this.hub.unregisterListener();
            this.started = false;
        }
        if (this.hub.connection.state === signalr_1.HubConnectionState.Disconnected) {
            return;
        }
        if (this.hub.canStop) {
            try {
                await this.hub.connection.stop();
                if (this.currentConnectionId) {
                    (0, signalRConnectionIdsCache_1.removeConnectionId)(this.currentConnectionId);
                    this.currentConnectionId = null;
                }
            }
            catch (err) {
                console.error(`SignalR: connection to ${this.hubName} could not be stopped. ${err}`);
                this.hub.registerListener();
                this.started = true;
            }
        }
    }
    on(messageName, callback) {
        const wrapper = (...args) => {
            const dateParsedArgs = args.map(arg => (0, parseISODates_1.default)(arg));
            if (callback) {
                callback(...dateParsedArgs);
            }
        };
        this.wrapperMapping.set(callback, wrapper);
        this.hub.connection.on(messageName, wrapper);
        return this;
    }
    off(messageName, callback) {
        const wrapper = this.wrapperMapping.get(callback) || callback;
        this.wrapperMapping.delete(callback);
        this.hub.connection.off(messageName, wrapper);
        return this;
    }
}
exports.default = HubClient;
//# sourceMappingURL=HubClient.js.map